import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-50/80">
      <div className="w-full px-4 md:px-6">
        <div className="py-14 md:py-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-booklet-line text-lg text-background-50"></i>
              </div>
              <span className="font-heading font-bold text-lg text-background-50">
                今日同人库
              </span>
            </div>
            <p className="text-sm leading-relaxed text-background-50/60">
              每日精选同人内容聚合平台，汇聚最新同人小说、同人画作、同人音乐与周边资讯。让同人热情燃烧不息。
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-sm mb-4 text-background-50">
              内容分类
            </h4>
            <ul className="space-y-2.5">
              {[
                { to: '/category/doujin-novel', label: '同人小说' },
                { to: '/category/doujin-art', label: '同人画作' },
                { to: '/category/doujin-music', label: '同人音乐' },
                { to: '/category/doujin-goods', label: '周边资讯' },
                { to: '/category/cp-recommend', label: 'CP推荐' },
              ].map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    className="text-sm text-background-50/60 hover:text-background-50/90 transition-colors cursor-pointer"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-sm mb-4 text-background-50">
              关于本站
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link
                  to="/about"
                  className="text-sm text-background-50/60 hover:text-background-50/90 transition-colors cursor-pointer"
                >
                  关于我们
                </Link>
              </li>
              <li>
                <Link
                  to="/about#contact"
                  className="text-sm text-background-50/60 hover:text-background-50/90 transition-colors cursor-pointer"
                >
                  联系我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-sm mb-4 text-background-50">
              关注我们
            </h4>
            <div className="flex items-center gap-3">
              {[
                { icon: 'ri-bilibili-line', label: 'Bilibili' },
                { icon: 'ri-weibo-line', label: '微博' },
                { icon: 'ri-wechat-line', label: '微信' },
                { icon: 'ri-tiktok-line', label: '抖音' },
              ].map((social) => (
                <a
                  key={social.label}
                  href="#"
                  className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-50/10 hover:bg-background-50/20 transition-colors cursor-pointer"
                  aria-label={social.label}
                  rel="nofollow"
                >
                  <i className={`${social.icon} text-sm`}></i>
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="py-5 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-50/40">
            &copy; {new Date().getFullYear()} 今日同人库 - 每日精选同人内容聚合平台. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-background-50/40 hover:text-background-50/60 transition-colors" rel="nofollow">
              隐私政策
            </a>
            <a href="#" className="text-xs text-background-50/40 hover:text-background-50/60 transition-colors" rel="nofollow">
              使用条款
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}